import axios from "axios";

export default {
	namespaced: true,
	state: {
		stats: null,
		billboards: [],
	},
	mutations: {
		setStats(state, payload) {
			state.stats = payload;
		},
		setBillboards(state, payload) {
			state.billboards = payload;
		},
		RESET(state) {
			state.stats = null;
			state.billboards = [];
		}
	},
	getters: {
		getStats: function (state) {
			return state.stats;
		},
		getBillboards: function (state) {
			return state.billboards;
		},
	},
	actions: {
		async search(ctx, {request = {}, start = 0, size = 12}) {
			try {
				const response = await axios.post(`/api/v1/billboard/search?start=${start}&size=${size}`, request);
				if (response?.status === 200) {
					ctx.commit("setBillboards", response?.data?.results);
				}
				return response?.data?.results;
			} catch(err) {
				console.log("Fail to query data billboards", err);
				return ctx.state.billboards;
			}
		},
		async getAll(ctx, {start = 0, size = 3000}) {
			return this.dispatch("api/billboard/search", {
				request: {
					active: true,
					point: {
						lat: 43.016,
						lng: -79.261,
					},
					// distance: 20000,
				},
				start: start,
				size: size,
			});
		},
		async getByIds(ctx, {ids = []}) {
			return this.dispatch("api/billboard/getAll", {}).then((response) => {
				return response.data.results.filter((item) => ids.includes(item.id));
			});

			// TODO: do nor remove, will use after get access to the endpoint for not SignIn user
			/* let requests = ids.map((id)=>{
			    return axios.get(`/api/v1/billboard/${id}`)
			});
			
			return axios.all(requests).then((response) => {
				return response.map((v) => v.data);
			}); */
		},
		async findOneRandomSponsor(ctx, {id}) {
			return axios.get(`/api/v1/billboard/${id}/sponsor`);
		},
		async findClosestSponsor(ctx, {start, size, dto}) {
			return axios.post(`/api/v1/billboard/closest?start=${start}&size=${size}`, dto);
		},
		async getSponsorsByBillboardId(ctx, {id}) {
			return axios.get(`/api/v1/billboard/${id}/sponsors`);
		},
		async createBillboard(ctx, {dto}) {
			return axios.post(`/api/v1/billboard/`, dto);
		},
		async updateBillboard(ctx, {id, dto}) {
			return axios.put(`/api/v1/billboard/${id}`, dto);
		},
		async deleteBillboard(ctx, {id}) {
			return axios.delete(`/api/v1/billboard/${id}`);
		},
		async addSponsor(ctx, {id, dto}) {
			return axios.post(`/api/v1/billboard/${id}/sponsor`, dto);
		},
		async updateSponsor(ctx, {id, dto}) {
			return axios.put(`/api/v1/billboard/${id}/sponsor`, dto);
		},
		async deleteSponsor(ctx, {id}) {
			return axios.delete(`/api/v1/billboard/sponsor/${id}`);
		},
		async getBillboardUsageSummary(ctx, {refresh = false} = {}) {
			if (ctx.state.subscriptions && ctx.state.subscriptions.length > 0 && !refresh)
				return Promise.resolve(ctx.state.subscriptions);

			return axios
				.get(`/api/v1/billboard/me/usage`)
				.then((res) => {
					if (res.status === 200) {
						let stats = res.data;
						ctx.commit("setStats", stats);
					} else {
						ctx.commit("setStats", null);
					}
					return res;
				})
				.catch((err) => {
					console.log("Fail to query data billboard usage", err);
				});
		},
	},
};
